var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 120,
    viewBox: "0 0 119 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.65 86.775V33.225L83.2 60L47.65 86.775ZM59.5 0.5C51.7192 0.5 44.0145 2.03901 36.826 5.02917C29.6375 8.01932 23.1058 12.4021 17.6039 17.9271C6.49239 29.0856 0.25 44.2196 0.25 60C0.25 75.7804 6.49239 90.9144 17.6039 102.073C23.1058 107.598 29.6375 111.981 36.826 114.971C44.0145 117.961 51.7192 119.5 59.5 119.5C75.2141 119.5 90.2845 113.231 101.396 102.073C112.508 90.9144 118.75 75.7804 118.75 60C118.75 52.1863 117.217 44.4492 114.24 37.2303C111.262 30.0115 106.898 23.4522 101.396 17.9271C95.8942 12.4021 89.3625 8.01932 82.174 5.02917C74.9855 2.03901 67.2808 0.5 59.5 0.5V0.5Z",
    fill: "#04AAF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.f154a4c4b0bb0e0d6ff5e2e66baf8b6a.svg";
export { ForwardRef as ReactComponent };